import React from "react";
import { getModuleUrl } from "./utils/module";
import { useLive } from "./LiveProvider";
import LiveHero from "./common/LiveHero";
import { Container, Grid, Cell, Link, Disclaimer } from "./styled/live-splash";

function LiveSplash() {
  const { theme, visibleModules } = useLive();

  return (
    <>
      <LiveHero />
      <Container className="splash-container">
        <Grid>
          {visibleModules.map((module) => (
            <Cell key={module.key}>
              <Link to={getModuleUrl(module)}>{module.previewEl}</Link>
            </Cell>
          ))}
        </Grid>
        {theme.disclaimer && <Disclaimer>{theme.disclaimer}</Disclaimer>}
      </Container>
    </>
  );
}

export default LiveSplash;
